export default "__VITE_ASSET__BaxdA8HL__"